// extracted by mini-css-extract-plugin
export default {"vacancyCreateWrapper":"singleVacancy_vacancyCreateWrapper__7fwsT"};